<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { fly } from "svelte/transition";
  import { portal } from "svelte-portal/src/Portal.svelte";

  export let isShow: boolean = false;
  export let withoutClose: boolean = false;

  let scrollbarWidth: number;

  const dispatch = createEventDispatcher();
  const animation = { y: 30, duration: 400 };

  const close = () => dispatch("close");

  function setLeftOffset(node: HTMLElement) {
    scrollbarWidth = node.offsetWidth - node.clientWidth;
  }
</script>

{#if isShow}
  <div
    use:portal
    use:setLeftOffset
    class="modal-wrapper {$$props.class || ''}"
    on:click={close}
  >
    <div
      class="modal g-centered"
      style="left: {scrollbarWidth / 2}px"
      on:click|stopPropagation
      in:fly={animation}
      out:fly={animation}
    >
      {#if !withoutClose}
        <button on:click={close} class="close">&times;</button>
      {/if}

      <slot />
    </div>
  </div>
{/if}

<style lang="scss">
  .modal-wrapper {
    @include absolute-wrapper;
    max-width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 100;
    position: fixed;
    display: flex;
    background-color: rgba(0, 0, 0, 0.76);
    padding-top: 80px;
    pointer-events: auto;

    @include md {
      padding-top: 60px;
    }

    :global(.close) {
      position: absolute;
      right: 15px;
      top: -35px;
      font-size: 3em;
      line-height: 0;
      color: $text-reverse-color;
      width: 30px;
      height: 30px;

      @media (min-width: $normal-width + 70px) {
        right: -35px;
        top: 0;
      }
    }
  }

  .modal {
    position: relative;
    color: $key-color;

    @media (max-width: $normal-width) {
      left: 0 !important;
    }
  }
</style>
